import * as i18n from '@/i18n'

export function translateTitle(title) {
    const dict = i18n.getLanguage()
    return dict[title] || title
}